/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarConfiguration = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M6.998 4V2h2v2h6V2h2v2h5v8.875a6.484 6.484 0 0 0-2-1.062V6h-3v2h-2V6h-6v2h-2V6h-3v14h7.816a6.483 6.483 0 0 0 1.062 2H1.998V4zM17 10v1.576a6.457 6.457 0 0 0-1.504.424H15v-2zm-4.124 4H11v2h.814a6.483 6.483 0 0 1 1.062-2zM7 12h2v-2H7zm6 0h-2v-2h2zm-6 4h2v-2H7zm15.998.999h-1.141a3.953 3.953 0 0 0-.424-1.02l.808-.808-1.414-1.414-.808.808a3.954 3.954 0 0 0-1.02-.424V13h-2v1.141a3.954 3.954 0 0 0-1.02.424l-.808-.808-1.414 1.414.808.808c-.186.316-.33.656-.424 1.02H13v2h1.141c.094.364.238.704.424 1.02l-.808.808 1.414 1.414.808-.808c.316.186.656.33 1.02.424v1.141h2v-1.141a3.954 3.954 0 0 0 1.02-.424l.808.808 1.414-1.414-.808-.808c.186-.316.33-.656.424-1.02h1.141zm-5 3a2 2 0 1 1 .001-4.001 2 2 0 0 1-.001 4.001z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCalendarConfiguration as CalendarConfiguration };
